import React from 'react';

/**
 * VariantModal — nayi product variant add karna (new separate product create hota hai).
 * Sabhi state Inventory.js mein hai; ye component sirf UI hai.
 *
 * Props:
 *   show            — boolean
 *   variantData     — { variantName, variantValue, price, buyingPrice, stock, offerPrice, ramGB, storageGB, color }
 *   variantLoading  — boolean
 *   onDataChange(updated) — setVariantData ke liye (partial update object)
 *   onSubmit()      — handleAddVariantSubmit
 *   onClose()       — setShowVariantModal(false)
 */
export default function VariantModal({ show, variantData, variantLoading, onDataChange, onSubmit, onClose }) {
  if (!show) return null;

  const set = (field, value) => onDataChange({ ...variantData, [field]: value });

  return (
    <div className="modal d-block" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Add Product Variant</h5>
            <button type="button" className="btn-close" onClick={onClose} />
          </div>

          <div className="modal-body">
            <div className="row g-3">
              <div className="col-md-6">
                <label className="form-label">Variant Name</label>
                <input
                  type="text"
                  className="form-control"
                  value={variantData.variantName}
                  onChange={(e) => set('variantName', e.target.value)}
                  placeholder="e.g., RAM/Storage"
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Variant Value <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  value={variantData.variantValue}
                  onChange={(e) => set('variantValue', e.target.value)}
                  placeholder="e.g., 8GB+128GB"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Price <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.price}
                  onChange={(e) => set('price', parseFloat(e.target.value) || 0)}
                  placeholder="Selling price"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">
                  Buying Price <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.buyingPrice}
                  onChange={(e) => set('buyingPrice', parseFloat(e.target.value) || 0)}
                  placeholder="Cost price"
                  required
                />
              </div>

              <div className="col-md-6">
                <label className="form-label">
                  Stock <span className="text-danger">*</span>
                </label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.stock}
                  onChange={(e) => set('stock', parseInt(e.target.value) || 1)}
                  min="1"
                  placeholder="Stock quantity"
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">Offer Price</label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.offerPrice}
                  onChange={(e) => set('offerPrice', parseFloat(e.target.value) || 0)}
                  placeholder="Special offer price (optional)"
                />
              </div>

              <div className="col-12">
                <h6 className="text-muted border-bottom pb-2">Specifications (Optional)</h6>
              </div>

              <div className="col-md-4">
                <label className="form-label">RAM (GB)</label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.ramGB}
                  onChange={(e) => set('ramGB', parseInt(e.target.value) || 0)}
                  placeholder="RAM"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Storage (GB)</label>
                <input
                  type="number"
                  className="form-control"
                  value={variantData.storageGB}
                  onChange={(e) => set('storageGB', parseInt(e.target.value) || 0)}
                  placeholder="Storage"
                />
              </div>
              <div className="col-md-4">
                <label className="form-label">Color</label>
                <input
                  type="text"
                  className="form-control"
                  value={variantData.color}
                  onChange={(e) => set('color', e.target.value)}
                  placeholder="Main color"
                />
              </div>

              <div className="col-12">
                <div className="alert alert-info mb-0">
                  <i className="bi bi-info-circle me-2"></i>
                  <strong>Note:</strong> This will create a new separate product with the variant details.
                  All other specifications will be inherited from the base product.
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={onSubmit}
              disabled={variantLoading}
            >
              {variantLoading ? (
                <>
                  <span className="spinner-border spinner-border-sm me-2"></span>
                  Adding...
                </>
              ) : (
                <>
                  <i className="bi bi-plus-square me-2"></i>
                  Add Variant
                </>
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
